import getHashCode from '../../utils/getHashCode';
import videoMilestonesReport from './milestonesReport';
import play from './play';

function milestonesTrack({ DDC }, event) {
	const {
		currentTarget: element,
		currentTarget: { currentSrc, currentTime, duration }
	} = event;
	const eventObjects = [];
	const id = getHashCode(currentSrc);
	const progress = currentTime / duration;
	const milestones = {
		0: false,
		25: false,
		50: false,
		75: false,
		95: false
	};

	const {
		dataLayer,
		dataLayer: { video = {} }
	} = DDC;
	dataLayer.video = video;

	video[id] = video[id] || milestones;

	if (!video[id]['0']) {
		video[id]['0'] = true;
		const autoplay = element.hasAttribute?.('autoplay');
		eventObjects.push(play(event, autoplay));
	}

	if (progress >= 0.25 && !video[id]['25']) {
		video[id]['25'] = true;
		eventObjects.push(videoMilestonesReport('25', element));
	} else if (progress >= 0.5 && !video[id]['50']) {
		video[id]['50'] = true;
		eventObjects.push(videoMilestonesReport('50', element));
	} else if (progress >= 0.75 && !video[id]['75']) {
		video[id]['75'] = true;
		eventObjects.push(videoMilestonesReport('75', element));
	} else if (progress >= 0.95 && !video[id]['95']) {
		video[id]['95'] = true;
		eventObjects.push(videoMilestonesReport('95', element));
	}

	return eventObjects;
}

export default milestonesTrack;
